import { useLingui } from "@lingui/react/macro";
import { ActionIcon, Tooltip } from "@mantine/core";
import { IconHelp } from "@tabler/icons-react";

/**
 * Help icon with a tooltip, meant to sit next to field labels.
 *
 * @param {object} props
 * @param {import("react").ReactNode} props.label - Tooltip content
 * @param {number} [props.width=220] - Tooltip width
 */
export function HelpIcon({ label, width = 220 }) {
	const { t } = useLingui();

	return (
		<Tooltip
			label={label}
			multiline
			withArrow
			w={width}
			events={{ hover: true, focus: true, touch: true }}
		>
			<ActionIcon
				variant="subtle"
				radius="xl"
				color="var(--mantine-color-dimmed)"
				aria-label={t`Ayuda`}
			>
				<IconHelp />
			</ActionIcon>
		</Tooltip>
	);
}
